import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./Home.module.css";

import Container from "@/layouts/container/Container";
import IncompleteCourses from "@/features/courses/components/incompleteCourses/IncompleteCourses";
import CourseSwiper from "@/features/courses/components/courseSwiper/CourseSwiper";
import CourseProgressBanner from "@/features/courses/components/courseProgressBanner/CourseProgressBanner";
import PathProgressBanner from "@/features/paths/components/pathProgressBanner/PathProgressBanner";

import { useGetRecentCourses } from "@/features/courses/hooks/useGetRecentCourses";
import { useGetContinueWatching } from "@/features/courses/hooks/useGetContinueWatching";
import { useGetMostLikedCourses } from "@/features/courses/hooks/useGetMostLikedCourses";

import FullPageLoader from "@/ui/fullPageLoader/FullPageLoader";
import Error from "@/ui/error/Error";
import { useGetAllCourses } from "@/features/courses/hooks/useGetAllCourses";

import { useUser } from "@/features/auth/hooks/useUser";
import { useGetMostWatchedCourses } from "@/features/courses/hooks/useGetMostWatchedCourses";
import { deriveCategoryRails } from "@/features/courses/deriveCategoryRails";

function SubscriberHome() {
	const { t } = useTranslation();
	const { user } = useUser();
	const [yes, setYes] = useState(true);

	const {
		courses: allCourses = [],
		isError: allCoursesError,
		isPending: allCoursesIsPending,
	} = useGetAllCourses();

	const freeCourses = React.useMemo(
		() => (allCourses || []).filter((course) => course.is_free),
		[allCourses]
	);

	const rails = React.useMemo(
		() => deriveCategoryRails(allCourses),
		[allCourses]
	);

	const {
		data: currentCourse,
		isError: currentError,
		isPending: currentPending,
	} = useGetContinueWatching();
	const {
		data: recentCourses,
		isError: recentError,
		isPending: recentPending,
	} = useGetRecentCourses();

	const {
		data: mostWatchedCourses,
		isError: watchedError,
		isPending: watchedPending,
	} = useGetMostWatchedCourses();

	const hasError =
		currentError || recentError || watchedError || allCoursesError;
	const isLoading =
		currentPending ||
		recentPending ||
		watchedPending ||
		allCoursesIsPending;

	if (hasError) return <Error />;
	if (isLoading) return <FullPageLoader />;

	return (
		<div className={style.page}>
			<div className={style.background}>
				<Container>
					{yes ? (
						<CourseProgressBanner courseData={currentCourse} />
					) : (
						<PathProgressBanner />
					)}
				</Container>
			</div>

			<Container>
				{!user?.is_subscribed && (
					<CourseSwiper
						title={t("courses:home.free")}
						courses={freeCourses}
					/>
				)}
				<CourseSwiper
					title={t("courses:home.recent")}
					courses={recentCourses}
				/>
				<IncompleteCourses />
				<CourseSwiper
					title={t("courses:home.mostWatched")}
					courses={mostWatchedCourses}
				/>

				{rails.biznis.length > 0 && (
					<CourseSwiper
						title={t("courses:home.bestBusiness")}
						courses={rails.biznis}
					/>
				)}

				{rails.tehnologija.length > 0 && (
					<CourseSwiper
						title={t("courses:home.bestTechnology")}
						courses={rails.tehnologija}
					/>
				)}

				{rails.kreativa.length > 0 && (
					<CourseSwiper
						title={t("courses:home.bestCreative")}
						courses={rails.kreativa}
					/>
				)}

				{rails.audio.length > 0 && (
					<CourseSwiper
						title={t("courses:home.audio")}
						description={t("courses:home.audioDescription")}
						courses={rails.audio}
					/>
				)}
			</Container>
			{/* <button
				className="absolute bottom-1 right-1 w-1 h-1 bg-yellow-500"
				onClick={() => setYes(!yes)}
			></button> */}
		</div>
	);
}

export default SubscriberHome;
